import React, { useState } from "react";
import Select from "react-select";
import { FiUploadCloud } from "react-icons/fi";
import "../SheetUpload/SheetBulkUploadPopup.scss";
import { useDispatch } from "react-redux";
import { smartConnectBulkUploadRequest } from "../../../Redux/Slice";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { getLoaderAction } from "../../../Redux/Loader";

const SmartConnectBulkUploadPopup = ({ setPopup }) => {
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();

  const recordTypeOptions = [

    { value: "0", label: "UDS Billable" },
    { value: "1", label: "UDS Non Billable" },
    { value: "2", label: "Denave Billable" },
    { value: "3", label: "Denave Non Billable" },
    { value: "4", label: "Athena Billable" },
    { value: "5", label: "Athena Non Billable" },
    { value: "6", label: "Avon Billable" },
    { value: "7", label: "Avon Non Billable" },
    { value: "8", label: "Fusion Food Billable" },
    { value: "9", label: "Fusion Food Non Billable" },
    { value: "10", label: "Global Billable" },
    { value: "11", label: "Global Non Billable" },
    { value: "12", label: "Matrix Billable" },
    { value: "13", label: "Matrix Non Billable" },
    { value: "14", label: "WHC Billable" },
    { value: "15", label: "WHC Non Billable" },
  ];

  const [selectedRecordType, setSelectedRecordType] = useState(
    recordTypeOptions[0]
  );

  const allowedTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  const MAX_SIZE = 250 * 1024 * 1024; // 250MB

  // Validate file
  const validateFile = (uploadedFile) => {
    if (!uploadedFile) return false;

    if (!allowedTypes.includes(uploadedFile.type)) {
      toast.error("Only Excel files (.xls, .xlsx) are allowed");
      return false;
    }

    if (uploadedFile.size > MAX_SIZE) {
      toast.error("File size should be less than 250MB");
      return false;
    }

    return true;
  };

  // Drag & Drop
  const handleDrop = (e) => {
    e.preventDefault();
    const uploadedFile = e.dataTransfer.files[0];
    if (!validateFile(uploadedFile)) return;
    setFile(uploadedFile);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // File Input
  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (!validateFile(uploadedFile)) return;
    setFile(uploadedFile);
  };

  // Upload
  const uploadFile = () => {
    const recordTypeValue = selectedRecordType?.value;

    if (!recordTypeValue && recordTypeValue !== "0" && recordTypeValue !== 0) {
      toast.error("Please select a record type");
      return;
    }

    if (!file) {
      toast.error("Please select a file");
      return;
    }

    const payload = {
      record_type: recordTypeValue,
      file: file,
      setPopup,
    };

    dispatch(smartConnectBulkUploadRequest(payload));
  };

  // Sample Download
  const downloadSample = () => {
    getLoaderAction(true);
    const headers = [
      "Employee Name",
      "Mobile Number",
      "Email Id",
      "Department",
      "Role",
      "Access",
      "Employee Code"
    ];

    const ws = XLSX.utils.aoa_to_sheet([headers]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sample");
    XLSX.writeFile(wb, "SmartConnect_Bulkupload_Sample.xlsx");
    getLoaderAction(false);
  };

  return (
    <div className="overlay">
      <div className="popupContainers">
        {/* Header */}
        <div className="popupHeader">
          <div />
          <span className="TitleHeader">Smart Connect Bulk Upload</span>
          <button className="closeButton" onClick={() => setPopup(false)}>
            ×
          </button>
        </div>

        {/* Dropdown & Sample Sheet */}
        <div
          className="uploadTypeHeader"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            marginBottom: "15px",
          }}
        >
          <div style={{ width: "220px" }}>

            <Select
              options={recordTypeOptions}
              value={selectedRecordType}
              onChange={(value) => setSelectedRecordType(value)}
              placeholder="Select Record Type"
              labelledBy="Select"
            />
          </div>

          <button
            className="sampleSheetBtn"
            onClick={downloadSample}
            style={{ textWrap: "nowrap", width: "35%" }}
          >
            Sample Sheet
          </button>
        </div>

        {/* Drag & Drop */}
        <div
          className="uploadBox"
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
          <FiUploadCloud className="uploadIcon" />

          <p className="mainText">
            Click to select or drag & drop your Excel file
          </p>

          <p className="subText">Supported formats: .xls, .xlsx</p>
          <p className="subText">Max file size 250MB</p>

          <input type="file" onChange={handleFileChange} accept=".xls,.xlsx" />

          {file && <p className="fileName">{file.name}</p>}
        </div>

        {/* Submit */}
        <button
          className="submitBtn"
          disabled={!file || !selectedRecordType}
          onClick={uploadFile}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default SmartConnectBulkUploadPopup;
